module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjQwOTYyIDkuNDE0ODNDNy4yMTA1NyA5LjY5OTE5IDYuNzg5NDQgOS42OTkxOSA2LjU5MDM4IDkuNDE0ODNMMC41NTA3MTQgMC43ODY3MzNDMC4zMTg3NDIgMC40NTUzNDMgMC41NTU4MTcgMCAwLjk2MDMyOSAwSDEzLjAzOTdDMTMuNDQ0MiAwIDEzLjY4MTMgMC40NTUzNDIgMTMuNDQ5MyAwLjc4NjczMUw3LjQwOTYyIDkuNDE0ODNaIiBmaWxsPSIjN0M4Q0FCIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dropdown_DownArrow.svg
// module id = lYso
// module chunks = 1